import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_2 = { class: "scroll-y mh-200px mh-lg-325px" }
const _hoisted_3 = ["href"]
const _hoisted_4 = { class: "symbol symbol-40px symbol-circle me-4" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "d-flex flex-column justify-content-start fw-bold" }
const _hoisted_7 = { class: "fs-6 fw-bold" }
const _hoisted_8 = { class: "fs-7 fw-bold text-muted" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data, (item, index) => {
          return (_openBlock(), _createElementBlock("a", {
            key: index,
            href: `/event/${item.id}`,
            class: "d-flex text-dark text-hover-primary align-items-center mb-5"
          }, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("img", {
                src: _ctx.site_url +'/'+ item?.main_image,
                alt: ""
              }, null, 8, _hoisted_5)
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("span", _hoisted_7, _toDisplayString(item?.name), 1),
              _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t('price_start_from')) + ": " + _toDisplayString(item?.price), 1)
            ])
          ], 8, _hoisted_3))
        }), 128))
      ])
    ])
  ], 64))
}